module.exports = __webpack_public_path__ + "img/hip.7f115347.svg";